/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable-next-line jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';
import { GetTableFooter } from '../../../_component/tableFooter';

export function AdminBanner(routeProps: RouteComponentProps) {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [items, setItems] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>([]);
  const [inputStatus, setInputStatus] = useState<number>(0);
  const [bannerFlag, setBannerFlag] = useState<Number>(1);
  const history = useHistory();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getBanners();
  }, [currentPage, bannerFlag]);

  const getBanners = async () => {
    if (bannerFlag === 1) {
      await server
        .getBannerFlag(currentPage, 10, 1)
        .then((payload1) => {
          // 협력사
          setItems(payload1.items);
          setMeta(payload1.meta);
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else {
      await server
        .getBannerFlag(currentPage, 10, 2)
        .then((payload2) => {
          // 교육기관
          setItems(payload2.items);
          setMeta(payload2.meta);
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  // 선택한 배너 -> setInputStatus
  const handleClickRadioBtn = (radioBtnName: number) => {
    setInputStatus(radioBtnName);
  };

  const updateBanner = (id: any) => {
    routeProps.history.push({
      pathname: `/admin/banner-logo/banner-mod/${id}`,
    });
  };

  // 배너값 불러오기
  const bannerRow = items?.map((item: any) => (
    <ul className="row" key={item.id}>
      <li className="check">
        <div className="check">
          <input
            id={item.id}
            type="radio"
            checked={inputStatus === item.id}
            onChange={() => handleClickRadioBtn(item.id)}
          />
          <label htmlFor={item.id} />
        </div>
      </li>
      <li className="counter" onClick={() => updateBanner(item.id)}>
        [수정]
      </li>
      <li className="book-title">
        <img
          src={`${process.env.REACT_APP_API_URL}/public${item.imageUrl}` || ''}
          alt={item.siteUrl}
        />
      </li>
      <li className="flex-20">{item.siteUrl}</li>
    </ul>
  ));

  // 배너 테이블
  function createBannerList() {
    return (
      <>
        <div className="bannerWrapper">
          <div className="radio">
            <input
              type="radio"
              defaultChecked={bannerFlag === 1}
              id="cooperative"
              name="flag"
              value="cooperative"
              onClick={() => setBannerFlag(1)}
            />
            <label
              htmlFor="cooperative"
              onClick={() => setBannerFlag(1)}
              style={{ display: 'flex' }}
            >
              <h3>협력사</h3>
            </label>
          </div>
          <div className="radio">
            <input
              type="radio"
              defaultChecked={bannerFlag === 2}
              id="academy"
              name="flag"
              value="academy"
              onClick={() => setBannerFlag(2)}
            />
            <label htmlFor="academy" onClick={() => setBannerFlag(2)} style={{ display: 'flex' }}>
              <h3>교육기관</h3>
            </label>
          </div>
        </div>
        <div className="table">
          <ul className="row title">
            <li className="check"> </li>
            <li className="counter">수정하기</li>
            <li className="book-title">이미지 (이미지 깨질 시 새로고침)</li>
            <li className="flex-20">URL</li>
          </ul>
          {bannerRow}
        </div>
      </>
    );
  }

  // 선택한 배너 삭제
  const onClickDelete = async () => {
    if (inputStatus <= 0) {
      dispatch(toast.error({ message: '선택된 항목이 없습니다.' }));
    } else {
      dispatch(toast.info({ message: '선택된 항목이 삭제되었습니다.' }));
      await server
        .deleteBanner(inputStatus)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: `서버로부터 응답이 없습니다.` }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: `파라미터 오류` }));
          }
          getBanners();
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  // AdminBanner 리턴값
  return (
    <main className="list images wrapper">
      <div className="title">
        <h1>협력사 / 교육기관 배너 관리</h1>
        <div className="buttons">
          <button
            type="button"
            onClick={() => {
              routeProps.history.push('/admin/banner-logo/banner-add');
            }}
          >
            등록하기
          </button>
        </div>
      </div>
      <div className="content">
        {createBannerList()}
        {GetTableFooter(
          meta?.currentPage,
          meta?.totalPages,
          (page: number) => setCurrentPage(page),
          '삭제',
          onClickDelete,
          true
        )}
      </div>
    </main>
  );
}
